import type { ChangeEventHandler } from "react";
import { H6, Checkbox, Small } from "orcs-design-system";

type FilterSearchSectionItem = {
  label: string;
  name: string;
};

type FilterSearchSectionProps = {
  items: FilterSearchSectionItem[];
  onChange: ChangeEventHandler<HTMLInputElement>;
  checkedItems?: string[];
};

const FilterSearchSection = (props: FilterSearchSectionProps) => {
  const { items, onChange, checkedItems = [] } = props;

  return (
    <>
      <H6 fontWeight="bold" mt="s">
        Filter results by:
      </H6>
      <Small color="subText" display="block">
        Selecting filters below will refine your search to only show results
        matching one (or more) of the following fields.
      </Small>
      {items &&
        items.map((item) => {
          return (
            <Checkbox
              key={item.name}
              label={item.label}
              name={item.name}
              checked={checkedItems.includes(item.name)}
              onChange={onChange}
            />
          );
        })}
    </>
  );
};

export default FilterSearchSection;
